<template>
  <el-form label-width="110px">
    <div class="m-b-10">菜单配置</div>
    <el-form-item label="上级菜单">
      <el-select v-model="pMenu" placeholder="上级菜单" class="w-150">
        <el-option v-for="item in menus" :label="item.title" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="菜单名称">
        <el-input class="w-150 h-40" v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="菜单类型">
      <el-select v-model="form.menu_type" placeholder="菜单类型" class="w-150">
        <el-option v-for="item in menuTypes" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="一级菜单标识">
      <el-input v-model="form.module" class="w-150 h-40" :disabled="form.pid != 0 && form.menu_type != 2"></el-input>
    </el-form-item>
    <el-form-item label="排序">
      <el-input v-model="form.sort" class="w-150 h-40"></el-input>
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="form.status" placeholder="状态" class="w-150">
        <el-option v-for="item in statusTypes" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="绑定权限规则">
      <el-input v-model.trim="form.rule_name" class="h-40 fl w-150 m-r-10" :disabled="true" placeholder="绑定权限规则"></el-input>
      <el-button size="small" class="fl" @click="openRule(form)">查找</el-button>
      <el-button size="small" class="fl m-l-5" @click="clearRule()">清空</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    props: {
      form: {
        type: Object,
        default() {
          return {}
        }
      },
      menus: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        statusTypes: [
          { id: 1, title: '启用' },
          { id: 0, title: '禁用' }
        ],
        menuTypes: [  // 菜单类型数组
          { id: 1, title: '三级菜单' },
          { id: 2, title: '单页菜单' }
        ],
        pMenu: {},
        formChange: false
      }
    },
    methods: {
      openRule(item) {
        this.$emit('openRule', item)
      },
      clearRule() {
        this.form.rule_name = ''
        this.form.rule_id = null
      }
    },
    watch: {
      'form'() {
        this.formChange = true
        _(this.menus).forEach((res) => {
          if (res.id == this.form.pid) {
            this.pMenu = res
            return false
          }
        })
      },
      'pMenu'() {
        if (this.formChange) {
          this.formChange = false
          return
        }
        this.form.pid = this.pMenu.id
        this.form.module = this.pMenu.module ? this.pMenu.module : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// menuForm.vue?111fa18d